<!--  -->
<template>
  <div class>
    <el-dialog
      title="论文信息"
      align="center"
      @close="handleClose"
      :visible.sync="dialogVisible"
      width="640px"
    >
      <div class="paper">
        <h5 class="title">{{detailObj.title}}</h5>
        <p>
          <span class="title">作者：</span>
          {{detailObj.author}}
        </p>
        <p>
          <span class="title">关键词：</span>
          {{detailObj.keywords}}
        </p>
        <p>
          <span class="title">内容提要：</span>
          {{detailObj.abstracts}}
        </p>
        <p class="mb20">
          <span class="title">原文出处：</span>
          《{{detailObj.orgpdc}}》 {{detailObj.year}}年第{{detailObj.orgpdcno}}期
        </p>
        <a
          v-if="detailObj.rucartid"
          :href="'https://www.rdfybk.com/qw/detail?id='+detailObj.rucartid"
          class="rdfyk"
          target="_blank"
        >人大复印库全文阅读 ></a>
        <h5 v-if="iframeSrc" class="title mt20">
          相关论文
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">
              箭头方向表示被引用，由于<br>
              引文关系非常复杂，本图仅<br>
              截选了相对热门的论文。
            
            </div>
            <img style="position: relative;top:3px" src="../../assets/question.svg" alt>
          </el-tooltip>
          <span @click="ckdt" class="fw">查看大图</span>
        </h5>
        <div v-if="iframeSrc" style="text-align:center">
          <iframe :src="iframeSrc" width="560" height="300" frameborder="0" scrolling="auto"></iframe>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      dialogVisible: false,
      data: {},
      iframeSrc: "",
      detailObj: {}
    };
  },
  props: {
    detailValue: String
    // props: ['post'],
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    open(id, code) {
      //   this.$nextTick(() => {
      this.getiSepaperGraph(id, code);
      this.getisepaperDetail(id, code);
      //   });
    },

    //论文详情页
    getisepaperDetail(pid, treecode) {
      let _this = this;
      _this.detailObj = {};
      let params = {
        pid: pid,
        treecode: treecode
      };
      _this.$api
        .fetchGet("/iseapi/getisepaperdetail", params)
        .then(res => {
          if (res.error === 0) {
            if (res.data) {
              _this.detailObj = res.data;
            }
          }
          this.dialogVisible = true;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getiSepaperGraph(pid, treecode) {
      let _this = this;
      _this.iframeSrc = ""
      let params = {
        pid: pid,
        treecode: treecode
      };
      _this.$api
        .fetchGet("/iseapi/getisepapergraph", params)
        .then(res => {
          if (res.error === 0) {
            if (res.data.length) {
              _this.iframeSrc = res.data[0]["graph"];
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    handleClose() {},
    ckdt() {
      window.open(this.iframeSrc);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.mb20 {
  margin-bottom: 20px;
}
.mt20 {
  margin-top: 20px;
}
.paper {
  text-align: left;
  padding: 0 20px;
}
.paper h5 {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.paper p {
  line-height: 24px;
}
.paper .rdfyk {
  color: #4267b2;
}
.paper .rdfyk::before {
  content: " ";
  background: url("../../assets/rdfyk.svg") no-repeat;
  background-size: 100%;
  margin-right: 5px;
  position: relative;
  top: 2px;
  display: inline-block;
  height: 14px;
  width: 16px;
}
</style>


// WEBPACK FOOTER //
// src/view/common/paperdetails.vue